import React from 'react';
import { useStaticQuery, graphql } from "gatsby"
import Img from 'gatsby-image';
import './styles.scss';
import ChartsImage from "./uptimechart.png";
import NotifyImage from "./notify3.png";
import KeyFeaturesEnterprise from '../KeyFeatures/enterprise';
import { Icons } from '@hyperping/design';

const Monitoring = () => {
  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "supernotes_statuspage.png" }) {
        childImageSharp {
          fluid(maxWidth: 1160) {
            ...GatsbyImageSharpFluid_noBase64
          }
        }
      }
    }
  `);

  return(
    <>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>

      <section className="features-monitoring">
        <div className="left">
          <div className="feature-tag flex font-mono padding-05em br-6px">Monitor</div>
          <h2 className="line-height-115em">24 types of checks from 19 regions</h2>
          <div className="mb-2em font-size-16px font-weight-300 line-height-143em">The stress of downtime never goes away, but it's easier to relax when 100% of your system is monitored instead of 80% or less.</div>

          <div className="flex flex-direction-column gap-075em">
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> HTTPS</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> SSL/Certificate</div>
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> ICMP</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> SSH</div>
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> SMTP</div>  
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> TCP Port</div>  
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> Cron jobs</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> Synthetic monitoring</div>  
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> Text assertion</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}}/> API monitoring</div>
            </div>
          </div>

          <div className="demo-link mt-2em">
            <a href="/uptime-monitoring">Learn more</a>
            <Icons size="small" name="chevronright" />
          </div>
        </div>
        <div className="right">
          <img src={ChartsImage} />
        </div>
      </section>

      <div className="mb5" />
      <div className="mb5" />
    
     <section className="features-monitoring status-page">
        <div className="left">
          <div className="feature-tag flex font-mono padding-05em br-6px">Notify</div>
          <h2 className="line-height-115em">Never miss a downtime notification again</h2>
          <div className="mb-2em font-size-16px font-weight-300 line-height-143em">Downtime notifications are super useful… if you're sure to see them and not miss the critical ones.</div>

          <div className="flex flex-direction-column gap-1em">
            <div className="flex text-align-flex-start font-size-16px gap-035em font-weight-300 line-height-143em" style={{display:'inline-block'}}><Icons size="large" className="min-width-20" name="check" style={{verticalAlign: 'middle',color:'#2BAC76'}} /> <span className="font-weight-400 color-white">Escalation policies:</span> Define the exact channels, people, and timing for your notifications.</div>
            <div className="flex text-align-flex-start font-size-16px gap-035em font-weight-300 line-height-143em"  style={{display:'inline-block'}}><Icons size="large" className="min-width-20" name="check" style={{verticalAlign: 'middle',color:'#2BAC76'}} /> <span className="font-weight-400 color-white">Integrations:</span> Be notified on your phone, Slack, Microsoft Teams, etc…</div>
            <div className="flex text-align-flex-start font-size-16px gap-035em font-weight-300 line-height-143em"  style={{display:'inline-block'}}><Icons size="large" className="min-width-20" name="check" style={{verticalAlign: 'middle',color:'#2BAC76'}} /> <span className="font-weight-400 color-white">Invite teammates:</span> Send alerts to the right people.</div>
          </div>

          <div className="demo-link mt-2em">
            <a href="/escalation-policies">Learn more</a>
            <Icons size="small" name="chevronright" />
          </div>
        </div>
        <div className="right">
          {/* <img src={StatusPage} /> */}
          <img src={NotifyImage} />
        </div>
      </section>

      <div className="mb5" />

     <section className="features-monitoring status-page">
        <div className="left">
          <div className="feature-tag flex font-mono padding-05em br-6px">Inform</div>
          <h2 className="line-height-115em">Snappy full-featured status pages</h2>
          <div className="mb-2em font-size-16px font-weight-300 line-height-143em">Status pages and update subscriptions are now expected by your customers, you can't cut corners.</div>

          <div className="flex flex-direction-column gap-075em">
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Custom domains</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Manuel Components</div>
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Subscriptions</div>
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Multi-language</div>
            </div>
            <div className="flex">
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Protected pages</div>  
              <div className="flex width-100 align-items-center font-size-16px gap-035em font-weight-300"><Icons size="large" name="check" style={{color:'#2BAC76'}} /> Incident management</div>  
            </div>
          </div>

          <div className="demo-link mt-2em">
            <a href="/status-page">Learn more</a>
            <Icons size="small" name="chevronright" />
          </div>

          {/* <div className="user-review">
            <p>”We picked Hyperping to bring a high quality incidents and status reporting dashboard to our users. It took us 30 minutes to setup, and it covered everything you want for a SaaS business.”</p>
            <div className="who">
              <img src={pierre} />
              <div className="name-title">
                <div className="name">Pierre Renaudin</div>
                CTO, Slite
              </div>
            </div>
          </div> */}
        </div>
        <div className="right">
          {/* <img src={StatusPage} /> */}
          <Img width="1160" fluid={data.file.childImageSharp.fluid} />
        </div>
      </section>

      <div className="mb5" />
      
      {/* <KeyFeaturesStatuspage /> */}

      {/* <IntegrationsCarousel darkMode={true} /> */}

      <KeyFeaturesEnterprise />

      <div className="mb5" />
    </>
  );
}

export default Monitoring;
